export default __webpack_public_path__ + "static/media/agent.bdf891a5.svg";